import { Button } from 'semantic-ui-react';
import { eventSlugnameTrim } from 'src/components/helpers';

export const GroupsAdminRow = ({
  set_selectedGroup,
  set_showGroupModal,
  showCapacity,
  showPendingTotals,
}) => [
  {
    headerName: 'Grupo',
    children: [
      {
        headerName: 'Nombre',
        field: 'groupName',
        width: 220,
      },
      {
        headerName: 'Categoría',
        field: 'activityName',
        width: 220,
        columnGroupShow: 'closed',
        valueGetter: (params) => eventSlugnameTrim(params?.data?.activityName || ''),
      },
      {
        headerName: 'Modalidad',
        field: 'online',
        width: 160,
        columnGroupShow: 'closed',
        valueGetter: (params) => (params?.data?.online ? 'Online' : 'Presencial'),
      },
    ],
  },
  {
    headerName: 'Líderes',
    children: [
      {
        headerName: 'Líder El',
        field: 'maleLeader',
        width: 200,
        valueGetter: (params) =>
          `${params?.data?.maleLeader?.name || ''} ${
            params?.data?.maleLeader?.lastName || ''
          }`.trim(),
      },
      {
        headerName: 'Líder Ella',
        field: 'femaleLeader',
        width: 200,
        valueGetter: (params) =>
          `${params?.data?.femaleLeader?.name || ''} ${
            params?.data?.femaleLeader?.lastName || ''
          }`.trim(),
      },
    ],
  },
  {
    headerName: 'Miembros',
    children: [
      {
        headerName: 'Miembros activos',
        field: 'membersCount',
        width: 160,
        valueGetter: (params) =>
          params?.data?.GroupMembers?.filter?.((m) => !m?.pending)?.length || 0,
      },
      ...(showCapacity
        ? [
            {
              headerName: 'Capacidad de Miembros',
              field: 'maxCapacity',
              width: 160,
              columnGroupShow: 'closed',
              valueGetter: (params) => params?.data?.maxCapacity || 0,
            },
          ]
        : []),
      ...(showPendingTotals
        ? [
            {
              headerName: 'Pendientes de aprobación',
              field: 'pendingTotal',
              width: 160,
              columnGroupShow: 'closed',
              valueGetter: (params) =>
                params?.data?.GroupMembers?.filter?.((m) => m?.pending)?.length || 0,
            },
          ]
        : []),
    ],
  },
  {
    headerName: 'Acciones',
    field: 'actions',
    width: 150,
    sortable: false,
    filter: false,
    cellRenderer: (params) => (
      <Button
        size="tiny"
        onClick={() => {
          set_selectedGroup(params?.data);
          set_showGroupModal(true);
        }}
      >
        Ver miembros
      </Button>
    ),
  },
];
